export enum ELocalStorageMobile {
	HIDE_PWA_INSTALL_WEB_MOBILE = 'hidePwaInstallButton',
	SHOWN_RECOMMEND_TECH_INFO = 'shownRecommendTechInfo',
}
